import { api } from "constants/RotasAPI";
import useFetch from "hooks/useFetch";
import { FiltroConfigAssDigitalCondominioPaginadasDTO } from "types/dto/groupsign/FiltroConfigAssDigitalCondominioPaginadas";
import { Page } from "types/dto/Page";

export const useGetConfigAssDigitalCondominioPaginadas = (params: FiltroConfigAssDigitalCondominioPaginadasDTO) => {
  const onSuccess = (response: any) => {
    return response;
  };

  return useFetch<Page<FiltroConfigAssDigitalCondominioPaginadasDTO>>({
    key: ["config-assinatura-digital", params],
    url: `${api.groupsign.configuracaoAssinaturaDigital}`,
    params: params,
    onSuccess,
  });
};
